<sgt-multi-select
  [settings]="settings"
  [options]="options"
  [variante]="variante"
  [(ngModel)]="origens"
  (ngModelChange)="onSelectionChange()"
  (search)="onSearch()">
</sgt-multi-select>
